<div class="container">
  <span>ADJUST GRAPHICS DURATION IN SECONDS:</span>
  <icn-number-input
    [theme]="'white'"
    [min]="minValue"
    [max]="maxValue"
    [step]="step"
    [value]="newDuration"
    (valueChange)="onValueChange($event)"
  ></icn-number-input>
</div>
